import { SystemDiagnosticMetricEnum } from './SystemDiagnosticMetricEnum'

export enum SystemDiagnosticCategoryEnum {
    SYSTEM_PERFORMANCE = 'system_performance',
    METERING_ERRORS = 'metering_errors',
    WIRING_AND_INSTALL_ERRORS = 'wiring_and_install_errors'
}

export const SYSTEM_DIAGNOSTIC_CATEGORIES = [
    {
        key: SystemDiagnosticCategoryEnum.SYSTEM_PERFORMANCE,
        title: 'System Performance',
        metrics: [
            SystemDiagnosticMetricEnum.TIME_ON_GRID,
            SystemDiagnosticMetricEnum.INTERNET_CONNECTIVITY,
            SystemDiagnosticMetricEnum.DAILY_AVERAGE_BATTERY_DISCHARGE,
            SystemDiagnosticMetricEnum.DAILY_AVERAGE_SOLAR_PRODUCTION,
            SystemDiagnosticMetricEnum.LOAD_DROPS
        ]
    },
    {
        key: SystemDiagnosticCategoryEnum.METERING_ERRORS,
        title: 'Metering Errors',
        metrics: [
            SystemDiagnosticMetricEnum.NEGATIVE_SOLAR_LOAD,
            SystemDiagnosticMetricEnum.NEGATIVE_HOME_LOAD
        ]
    },
    {
        key: SystemDiagnosticCategoryEnum.WIRING_AND_INSTALL_ERRORS,
        title: 'Wiring & Install Errors',
        metrics: [
            SystemDiagnosticMetricEnum.FLOATING_GROUND,
            SystemDiagnosticMetricEnum.GRID_COMPLIANCE,
            SystemDiagnosticMetricEnum.POWERWALL_DISCONNECTED
        ]
    }
]
